import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "flex flex-row items-center space-x-2"
};
const _hoisted_2 = {
  class: "flex flex-row items-center space-x-2"
};
const _hoisted_3 = {
  class: "flex flex-row items-center space-x-2"
};
const _hoisted_4 = {
  key: 0,
  class: "warning-note"
};
const _hoisted_5 = {
  key: 0,
  class: "fa fa-cog fa-spin",
  style: {
    "margin-right": "5px"
  }
};
import { onMounted, reactive, computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { storeToRefs } from 'pinia';
import { useTrustAccountingStore } from '@/services/trustAccountingStore';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useGravityValidationStore } from '@/services/useGravityValidationStore';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlTextField from '@/components/LlTextField.vue';
export default {
  __name: 'EditTrustAccountDialog',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    trustAccountingState: {
      type: Object,
      required: false
    },
    tracking: {
      type: Object,
      required: true
    }
  },
  emits: ['closeEditTrustAccountDialog', 'reload', 'cancel', 'disconnect'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const trustAccountingStore = useTrustAccountingStore();
    trustAccountingStore.alerts = props.alerts;
    const {
      features,
      me,
      company
    } = storeToRefs(useMeStore());
    const {
      validateConfidoEnabled
    } = useGravityValidationStore();
    const {
      confidoValidation
    } = storeToRefs(useGravityValidationStore());
    const {
      confidoTrustAccounts
    } = storeToRefs(trustAccountingStore);
    let setupStartTime = Date.now();
    let hadDuplicateWarning = false;
    const getBaseTrackingParams = () => {
      return {
        email: me.value?.email || '',
        name: me.value?.name || '',
        role: me.value?.role || '',
        created_at: new Date().toISOString(),
        companyName: company.value?.name || '',
        companyStatus: company.value?.status || '',
        number_of_trust_accounts: props.trustAccountingState?.accounts?.length || 0
      };
    };
    const trackEvent = (category, action, additionalParams = {}) => {
      const baseParams = getBaseTrackingParams();
      props.tracking?.event(category, action, {
        ...baseParams,
        ...additionalParams
      });
    };
    const emit = __emit;
    const editTrustAccountState = reactive({
      dialog: true,
      loading: false,
      saving: false,
      modelOne: false,
      modelTwo: false,
      clientsCount: 0,
      checkTrustAndDisconnect: false,
      confirmDisconnect: false,
      account: {},
      trustAccount: {
        label: '',
        bankAccount: null,
        liabilityAccount: null,
        isDefault: false
      },
      accountingAccounts: {
        bank: [],
        liability: []
      },
      account: {
        defaultAccount: false
      },
      confidoEnabled: false,
      confidoTrustAccount: {
        id: null,
        nickname: null
      }
    });
    onMounted(async () => {
      setupStartTime = Date.now();
      editTrustAccountState.loading = true;
      const configuration_type = props.trustAccountingState?.editingTrust?.id ? 'modification' : 'new_setup';
      try {
        // If confidoTrustAccounts is populated on mount, track success
        if (confidoTrustAccounts.value && confidoTrustAccounts.value.length > 0) {
          trackEvent('trust', 'confido_account_fetch', {
            status: 'success',
            configuration_type,
            setup_duration: Date.now() - setupStartTime,
            account_count: confidoTrustAccounts.value.length,
            warning_type: 'none'
          });
        }
      } catch (error) {
        trackEvent('trust', 'confido_account_fetch', {
          status: 'error',
          configuration_type,
          setup_duration: Date.now() - setupStartTime,
          error_message: error.message || 'Unknown error',
          warning_type: 'fetch_error'
        });
      }
      const confidoTrustAccountId = props.trustAccountingState?.editingTrust?.confidoTrustAccountId;
      if (confidoTrustAccountId && confidoTrustAccounts.value) {
        editTrustAccountState.confidoTrustAccount = confidoTrustAccounts.value.find(account => account.id === confidoTrustAccountId) || {};
      } else if (showConfidoSection.value && confidoTrustAccounts.value?.length === 1) {
        editTrustAccountState.confidoTrustAccount = confidoTrustAccounts.value[0];
      }
      editTrustAccountState.trustAccount.label = props.trustAccountingState?.editingTrust?.label;
      if (props.trustAccountingState?.accountingAccounts) {
        editTrustAccountState.accountingAccounts.bank = props.trustAccountingState.accountingAccounts.bank;
        editTrustAccountState.accountingAccounts.liability = props.trustAccountingState.accountingAccounts.liability || [];
      }
      if (props.trustAccountingState?.editingTrust?.id) {
        editTrustAccountState.showDisconnect = true;
        const account = trustAccountingStore.trustFromId(props.trustAccountingState?.editingTrust?.id);
        editTrustAccountState.account = account;
        editTrustAccountState.account.defaultAccount = account.defaultAccount;
        editTrustAccountState.trustAccount.liabilityAccount = account.liability;
        editTrustAccountState.trustAccount.bankAccount = account.bank;
      } else {
        editTrustAccountState.account = {};
        editTrustAccountState.showDisconnect = false;
        setLabel();
      }
      editTrustAccountState.loading = false;
    });
    const showConfidoSection = computed(() => {
      return features.value?.confidoMultiTrust && confidoValidation.value?.validToken;
    });
    const isConfidoAccountInUse = computed(() => {
      if (!editTrustAccountState.confidoTrustAccount?.id || !props.trustAccountingState?.accounts) {
        return false;
      }

      // Check if any other trust account is using this Confido account
      return props.trustAccountingState.accounts.some(account => account.confidoTrustAccountId === editTrustAccountState.confidoTrustAccount.id && account.id !== props.trustAccountingState?.editingTrust?.id);
    });
    const cancel = () => {
      emit('closeEditTrustAccountDialog');
      editTrustAccountState.dialog = false;
    };
    const closeConfirmationDialog = () => {
      editTrustAccountState.modelOne = false;
      editTrustAccountState.modelTwo = false;
    };
    const existing = account => {
      return props.trustAccountingState?.accounts?.find(a => a.liability.id == account.id || a.bank.id == account.id);
    };
    const setLabel = () => {
      const label = `Trust Account ${props.trustAccountingState?.accounts?.length + 1}`;
      editTrustAccountState.trustAccount.label = label;
    };
    const save = async () => {
      const defaultAccount = editTrustAccountState.account.defaultAccount;
      const label = editTrustAccountState.trustAccount.label;
      editTrustAccountState.saving = true;
      if (editTrustAccountState.trustAccount?.bankAccount) {
        const found = existing(editTrustAccountState.trustAccount?.bankAccount);
        if (found && found.id != editTrustAccountState.account?.id) {
          trackEvent('trust', 'duplicate_warning_shown', {
            configuration_type: props.trustAccountingState?.editingTrust?.id ? 'modification' : 'new_setup',
            warning_type: 'duplicate_bank_account',
            setup_duration: Date.now() - setupStartTime
          });
          hadDuplicateWarning = true;
          editTrustAccountState.saving = false;
          return props.alerts?.error('You already have a trust account set up that is using this bank account');
        }
      }
      const trustAccount = {
        id: props.trustAccountingState?.editingTrust?.id,
        label: label,
        bank: await getBankAccount(),
        liability: await getLiabilityAccount(),
        defaultAccount: defaultAccount,
        confidoTrustAccountId: editTrustAccountState.confidoTrustAccount?.id || null // Add the confidoTrustAccountId
      };
      const configuration_type = trustAccount.id ? 'modification' : 'new_setup';
      const setup_duration = Date.now() - setupStartTime;

      // Track special event if Confido account is configured
      if (editTrustAccountState.confidoTrustAccount?.id) {
        trackEvent('trust', 'trust_account_configured', {
          configuration_type,
          setup_duration,
          warning_type: isConfidoAccountInUse.value ? 'shared_confido_account' : 'none'
        });
      }
      if (!trustAccount.id) {
        editTrustAccountState.saving = true;
        const addTrust = await trustAccountingStore.addTrust(trustAccount);
        editTrustAccountState.saving = false;
        editTrustAccountState.dialog = false;
        if (hadDuplicateWarning) {
          trackEvent('trust', 'duplicate_warning_resolved', {
            configuration_type,
            setup_duration,
            resolution_type: 'created_new_account',
            warning_type: 'duplicate_bank_account_resolved'
          });
          hadDuplicateWarning = false;
        }
        trackEvent('trust', 'trust_account_created', {
          configuration_type,
          setup_duration,
          warning_type: 'none'
        });
        emit('reload', addTrust);
      } else {
        editTrustAccountState.saving = true;
        const updateTrust = await trustAccountingStore.updateTrust(trustAccount);
        editTrustAccountState.saving = false;
        editTrustAccountState.dialog = false;
        if (hadDuplicateWarning) {
          trackEvent('trust', 'duplicate_warning_resolved', {
            configuration_type,
            setup_duration,
            resolution_type: 'modified_existing_account',
            warning_type: 'duplicate_bank_account_resolved'
          });
          hadDuplicateWarning = false;
        }
        trackEvent('trust', 'trust_account_updated', {
          configuration_type,
          setup_duration,
          warning_type: 'none'
        });
        emit('reload', updateTrust);
      }
    };
    const disconnect = async () => {
      editTrustAccountState.modelOne = true;
    };
    const checkTrustAndDisconnect = async () => {
      const trustId = props.trustAccountingState?.editingTrust?.id;
      editTrustAccountState.checkTrustAndDisconnect = true;
      const check = await trustAccountingStore.trustCheck(trustId);
      editTrustAccountState.clientsCount = check.clients ? check.clients : 0;
      if (check.clients === 0) {
        editTrustAccountState.modelOne = false;
        editTrustAccountState.modelTwo = false;
        confirmDisconnect();
      } else {
        editTrustAccountState.checkTrustAndDisconnect = false;
        editTrustAccountState.modelOne = false;
        editTrustAccountState.modelTwo = true;
        editTrustAccountState.dialog = false;
      }
    };
    const confirmDisconnect = async () => {
      editTrustAccountState.account.liability = null;
      editTrustAccountState.account.bank = null;
      editTrustAccountState.account.defaultAccount = false;
      editTrustAccountState.account.label = '';
      editTrustAccountState.confirmDisconnect = true;
      const response = await trustAccountingStore.deleteTrust(props.trustAccountingState?.editingTrust);
      if (response) {
        emit('reload');
      }
      editTrustAccountState.modelTwo = false;
      editTrustAccountState.dialog = false;
    };
    const getBankAccount = async () => {
      if (editTrustAccountState.trustAccount.bankAccount) {
        return editTrustAccountState.trustAccount.bankAccount;
      }
      let name = editTrustAccountState.trustAccount.label;
      let number = 2;
      while (props.trustAccountingState.accountingAccounts?.bank?.find(a => a.name === name)) {
        name = `${editTrustAccountState.trustAccount.label} ${number++}`;
      }
      return await trustAccountingStore.createAccountingAccount({
        name,
        type: 'Bank',
        subtype: 'TrustAccounts'
      });
    };
    const getLiabilityAccount = async () => {
      if (editTrustAccountState.trustAccount.liabilityAccount) {
        return editTrustAccountState.trustAccount.liabilityAccount;
      }
      let name = 'Funds Held in Trust';
      if (props.trustAccountingState.accountingAccounts.liability?.find(a => a.name === name)) {
        name = `Funds Held in Trust (${editTrustAccountState.trustAccount.label})`;
        let number = 2;
        while (props.trustAccountingState.accountingAccounts.liability?.find(a => a.name === name)) {
          name = `Funds Held in Trust ${number++}`;
        }
      }
      return await trustAccountingStore.createAccountingAccount({
        name,
        type: 'OtherCurrentLiability',
        subtype: 'TrustAccountsLiabilities'
      });
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_switch = _resolveComponent("v-switch");
      const _component_v_form = _resolveComponent("v-form");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_container = _resolveComponent("v-container");
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_v_dialog, {
        "onClick:outside": cancel,
        modelValue: editTrustAccountState.dialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => editTrustAccountState.dialog = $event),
        scrollable: "",
        width: "740",
        height: "680"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_container, null, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("Edit Trust Account", -1)]))]),
              _: 1
            }), editTrustAccountState.loading ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
              key: 0,
              type: "table-tbody ,table-tbody"
            })) : (_openBlock(), _createBlock(_component_v_card_text, {
              key: 1
            }, {
              default: _withCtx(() => [_createVNode(_component_v_form, null, {
                default: _withCtx(() => [_createVNode(_component_v_row, null, {
                  default: _withCtx(() => [_createVNode(_component_v_col, {
                    cols: "12",
                    sm: "5"
                  }, {
                    default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createElementVNode("label", null, "Label:", -1)]))]),
                    _: 1
                  }), _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "7"
                  }, {
                    default: _withCtx(() => [_createVNode(LlTextField, {
                      type: 'text',
                      label: "",
                      modelValue: editTrustAccountState.trustAccount.label,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => editTrustAccountState.trustAccount.label = $event)
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [_createVNode(_component_v_col, {
                    cols: "12",
                    sm: "5"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createElementVNode("label", null, "Trust Bank Account", -1)]))]),
                    _: 1
                  }), _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "7"
                  }, {
                    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("img", {
                      src: "/img/qb16x16.png",
                      class: "w-5 h-5 mt-6"
                    }, null, -1)), _createVNode(LlSelect, {
                      label: "Trust Bank Account",
                      modelValue: editTrustAccountState.trustAccount.bankAccount,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => editTrustAccountState.trustAccount.bankAccount = $event),
                      items: editTrustAccountState?.accountingAccounts?.bank,
                      "item-title": "name",
                      "item-value": "id",
                      variant: "outlined",
                      "hide-details": "true",
                      "return-object": "",
                      isAutocomplete: "",
                      clearable: true,
                      class: "w-full"
                    }, null, 8, ["modelValue", "items"])]), _cache[10] || (_cache[10] = _createElementVNode("span", {
                      class: "edit-note"
                    }, " If you don't pick an account, we will create one for you. ", -1))]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [_createVNode(_component_v_col, {
                    cols: "12",
                    sm: "5"
                  }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createElementVNode("label", null, "Trust Liability Account", -1)]))]),
                    _: 1
                  }), _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "7"
                  }, {
                    default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_cache[12] || (_cache[12] = _createElementVNode("img", {
                      src: "/img/qb16x16.png",
                      class: "w-5 h-5 mt-6"
                    }, null, -1)), _createVNode(LlSelect, {
                      label: "Trust Liability Account",
                      modelValue: editTrustAccountState.trustAccount.liabilityAccount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => editTrustAccountState.trustAccount.liabilityAccount = $event),
                      items: editTrustAccountState?.accountingAccounts?.liability,
                      "item-title": "name",
                      "item-value": "id",
                      "return-object": "",
                      variant: "outlined",
                      "hide-details": "true",
                      isAutocomplete: "",
                      clearable: true,
                      class: "w-full"
                    }, null, 8, ["modelValue", "items"])]), _cache[13] || (_cache[13] = _createElementVNode("span", {
                      class: "edit-note"
                    }, " If you don't pick an account, we will create one for you. ", -1))]),
                    _: 1
                  })]),
                  _: 1
                }), showConfidoSection.value ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 0
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_col, {
                    cols: "12",
                    sm: "5"
                  }, {
                    default: _withCtx(() => [_createElementVNode("label", null, [_cache[15] || (_cache[15] = _createTextVNode("Confido Bank Account ", -1)), _createVNode(LlTooltip, {
                      icon: "help"
                    }, {
                      default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode(" If left blank, all trust requests for this account will be deposited to your default Confido trust account ", -1)]))]),
                      _: 1
                    })])]),
                    _: 1
                  }), _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "7"
                  }, {
                    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_cache[16] || (_cache[16] = _createElementVNode("img", {
                      src: "/img/confido-logo.png",
                      class: "w-5 h-5 mt-6"
                    }, null, -1)), _createVNode(LlSelect, {
                      label: "Trust Bank Account",
                      modelValue: editTrustAccountState.confidoTrustAccount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => editTrustAccountState.confidoTrustAccount = $event),
                      items: _unref(confidoTrustAccounts),
                      "item-title": "nickname",
                      "item-value": "id",
                      "return-object": "",
                      variant: "outlined",
                      "hide-details": "true",
                      isAutocomplete: "",
                      clearable: true,
                      class: "w-full"
                    }, null, 8, ["modelValue", "items"])]), isConfidoAccountInUse.value ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Be advised: one or more trust accounts is already using this bank account ")) : _createCommentVNode("", true)]),
                    _: 1
                  })]),
                  _: 1
                })) : _createCommentVNode("", true), _createVNode(_component_v_row, {
                  class: "basic-switch"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_col, {
                    cols: "12",
                    sm: "5"
                  }, {
                    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createElementVNode("label", null, "Default Account", -1)]))]),
                    _: 1
                  }), _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "7"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_switch, {
                      modelValue: editTrustAccountState.account.defaultAccount,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => editTrustAccountState.account.defaultAccount = $event),
                      color: "primary"
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_v_row, {
                  class: "d-flex m-4 justify-space-between"
                }, {
                  default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                    color: "primary",
                    onClick: save,
                    class: "d-flex m-4 w-1/3",
                    disabled: editTrustAccountState.saving
                  }, {
                    default: _withCtx(() => [editTrustAccountState.saving ? (_openBlock(), _createElementBlock("i", _hoisted_5)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(editTrustAccountState.saving ? 'Saving...' : 'Save'), 1)]),
                    _: 1
                  }, 8, ["disabled"]), __props.trustAccountingState.editingTrust?.id ? (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 0,
                    onClick: disconnect,
                    class: "d-flex m-4 w-1/3 disconnect"
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [_createTextVNode("Disconnect", -1)]))]),
                    _: 1
                  })) : _createCommentVNode("", true), _createVNode(LlSecondaryButton, {
                    class: "m-4",
                    onClick: cancel
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("Cancel", -1)]))]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(ConfirmationDialog, {
        dialog: editTrustAccountState.modelOne,
        content: "This will disconnect LeanLaw from the trust account in QuickBooks.\n     It will not make changes in QuickBooks. Would you like to proceed?`\n    ",
        toggleText: "Cancel",
        confirmText: editTrustAccountState.checkTrustAndDisconnect ? 'Disconnecting...' : 'Ok',
        onToggleDialog: closeConfirmationDialog,
        onConfirm: checkTrustAndDisconnect
      }, null, 8, ["dialog", "confirmText"]), _createVNode(ConfirmationDialog, {
        dialog: editTrustAccountState.modelTwo,
        content: `You have ${editTrustAccountState.clientsCount} clients connected to this trust account. If you click Ok, we will disconnect the clients 
    from this trust liability accounts as well.If you are trying to change bank accounts for these clients, 
    select CANCEL and use the 'Trust Bank Account' dropdown to reassign its QuickBooks Online account.`,
        toggleText: "Cancel",
        confirmText: editTrustAccountState.confirmDisconnect ? 'Disconnecting...' : 'Disconnect',
        onToggleDialog: closeConfirmationDialog,
        onConfirm: confirmDisconnect
      }, null, 8, ["dialog", "content", "confirmText"])], 64);
    };
  }
};